import React from 'react'
import Button from 'react-bootstrap/Button'

const AddFilterBtn = ({ disabled, onClick }) => {
  return (
    <Button
      className='add-filter'
      variant='outline-primary'
      disabled={disabled}
      onClick={onClick}
    >
      Add filter
    </Button>
  )
}

export default AddFilterBtn
